<template>
    <div class='basket-popout-container' id='basket_popout_container'>
        <div class='basket-popout-top-section' v-show='section == "cart"'>
            <div class='header'> 
                <div class='title'>Basket</div>
                <div class='close-button' @click='closePopout'><i class="fa-thin fa-xmark"></i></div>
            </div>
            <Separator/>
            
            <div class='items'>
                <div class='items-list'>
                    <div v-if='cart.length == 0' class='basket-empty-message'>Your basket is empty</div>
                    <div v-for='item in cart' :key='item.product_id'>
                        <Item :item='item' @updatedCartListener='updatedCartListener'/>
                    </div>
                </div>
            </div>
        </div>

        <div class='footer' v-show='section == "cart"'>
            <div class='footer-content'>
                <div class='footer-totals'>
                    <div class='total-text'>Total <span class='number-of-items-text'>({{total_items}} item<span v-show='total_items != 1'>s</span>)</span></div>
                    <div class='total-text'>£{{cart_total}}</div>
                </div>
                <div class='open-cart-button'>
                    <Button @click='continueToCheckout' text='continue to checkout' theme='dark' :disabled='total_items == 0'/>
                    <Button @click='openRecommendedProducts' text='View recommended products' theme='light' v-show='total_items != 0'/>
                </div>
            </div>
        </div>

        <div v-show='section == "recommended_products"'>
            <RecommendedCartProducts :total_items='total_items' @continueToCheckoutListener='continueToCheckout' @returnToBasketListener='returnToBasket' @viewProductListener='viewProduct'/>
        </div>

        <div v-show='section == "single_product"'>
            <ProductOnPopout :product_code='product_code' :product_code_changed_watcher='product_code_changed_watcher' @returnToRecommendedProductsListener='openRecommendedProducts' @updatedCartListener='updatedCartFromProductPopoutListener' @colourClickedListener='colourClicked' />
        </div>

    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';
import Item from '@/ecom/components/navigation/header/basket/Item.vue';
import Separator from '@/ecom/components/separators/Separator.vue';
import RecommendedCartProducts from '@/ecom/components/navigation/header/basket/RecommendedCartProducts.vue';
import ProductOnPopout from '@/ecom/components/navigation/header/basket/ProductOnPopout.vue';

export default {
    components: {Button, Item, Separator, RecommendedCartProducts, ProductOnPopout},
    props: ['cart', 'cart_total', 'total_items', 'open_watcher'],
    emits: ['continueToCheckoutListener', 'closePopOutListener', 'updatedCartListener'],
    data(){
        return{
            section: 'cart',
            product_code: '',
            product_code_changed_watcher: null
        }
    },
    methods:{
        continueToCheckout(){
            this.$emit('continueToCheckoutListener');
        },
        closePopout(){
            this.$emit('closePopOutListener');
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        updatedCartFromProductPopoutListener(){
            this.openRecommendedProducts();
            this.$emit('updatedCartListener');
        },
        openRecommendedProducts(){
            this.section = 'recommended_products';
            this.scrollToTop();
        },
        returnToBasket(){
            this.section = 'cart';
        },
        viewProduct(product_code){
            this.scrollToTop();
            this.section = 'single_product';
            this.product_code = product_code;
            this.product_code_changed_watcher = +new Date();
        },
        colourClicked(product_code, url){
            this.viewProduct(product_code);
        },
        scrollToTop(){
            document.getElementById('basket_popout').scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    watch:{
        'open_watcher': function(){
            this.section = 'cart';
        }
    }
}
</script>

<style lang="scss" scoped>

.basket-popout-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}


.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
}

.close-button{
    font-size: 1.5rem;
    cursor: pointer;
}

.title{
    font-size: 1.4rem;
    font-weight: 600;
}

.items{
    padding: 20px;
}

.items-list{
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
    overflow-x:hidden; 
    scrollbar-width: thin; //Firefox only
    scrollbar-color: darkgrey white; //Firefox only
    height: calc(90dvh - 200px);
}

.items-list::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.items-list::-webkit-scrollbar-track { //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.items-list::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.footer{
    box-shadow: 0 -5px 15px rgba(0,0,0,.1);
    height: 200px;
}

.footer-content{
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.footer-totals{
    display: flex;
    justify-content: space-between;
}
.open-cart-button{
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    // margin-top: 10px;
}

.total-text{
    font-weight: 600;
}

.number-of-items-text{
    font-weight: 400;
    font-size: 0.9rem;
}
</style>